import { PremiseTag } from 'app/premises/Premise';
import { FC } from 'react';

export type VacantIconProps = { tag?: PremiseTag };
export const Vacant: FC<VacantIconProps> = ({ tag }) => (
  <svg
    fill="#037A35"
    xmlns="http://www.w3.org/2000/svg"
    width="19.25"
    height="19.25"
    viewBox="0 0 19.25 19.25"
    role="img"
    aria-label={tag}
  >
    <path
      className="st0"
      d="M9.62 19.25C4.32 19.25 0 14.93 0 9.62 0 4.32 4.32 0 9.62 0c5.31 0 9.62 4.32 9.62 9.62.01 5.31-4.31 9.63-9.62 9.63zm0-17.87c-4.55 0-8.25 3.7-8.25 8.25s3.7 8.25 8.25 8.25 8.25-3.7 8.25-8.25-3.7-8.25-8.25-8.25z"
    />
    <path className="st0" d="M10.31 13.75H8.94V5.5s.01-.01 1.38 0c-.01.96-.01 8.25-.01 8.25z" />
  </svg>
);
